import apiFleetManager from "@Config/api/clientFleetManager";

/**
 * Verifica se o usuário autenticado ainda tem acesso à empresa informada.
 * Usado pelo CompanyContext na inicialização para revalidar a última empresa
 * selecionada. Se o acesso foi revogado, a empresa é limpa.
 */
export const customersApi = {
  verifyCustomerAccess: (customerId: number): Promise<boolean> =>
    apiFleetManager
      .get(`api/users/customers/${customerId}`, {
        // Não dispara o toast global de 403 — a negação aqui é esperada.
        ...({ skipForbiddenHandler: true } as any),
      })
      .then(() => true)
      .catch((error) => {
        if (error.response?.status === 403 || error.response?.status === 404) {
          return false;
        }
        // Erro transitório: propaga para o chamador decidir (mantém empresa).
        throw error;
      }),
};
